var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Link",
    transform: "translate(-284 -194)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8612",
    "data-name": "Rectangle 8612",
    width: 18,
    height: 18,
    transform: "translate(284 194)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_4",
    d: "M-1632.115-686.942a2.352,2.352,0,0,1-1.7-1.418,2.247,2.247,0,0,1,.472-2.5c.756-.8,1.512-1.559,2.315-2.315a2.42,2.42,0,0,1,2.93-.283.581.581,0,0,1,.331.52.674.674,0,0,1-.284.567.722.722,0,0,1-.851.141.85.85,0,0,0-.756-.094,1.479,1.479,0,0,0-.473.236c-.756.708-1.465,1.465-2.173,2.173a.932.932,0,0,0-.284.661.932.932,0,0,0,.284.661.933.933,0,0,0,.661.284.933.933,0,0,0,.661-.284l1.039-1.039c.047-.047.094-.094.142-.047a3,3,0,0,0,1.7.236h0l-.094.094-1.8,1.8a2.406,2.406,0,0,1-1.654.708C-1631.831-686.893-1631.972-686.893-1632.115-686.942Zm2.362-3.354c-.094-.047-.189-.141-.284-.189a.472.472,0,0,1-.189-.52.753.753,0,0,1,.425-.567.921.921,0,0,1,.708,0,.954.954,0,0,0,1.275-.189l2.22-2.22a.864.864,0,0,0,.284-.8.836.836,0,0,0-.52-.661.863.863,0,0,0-1.039.189l-1.134,1.134c-.047.047-.141.094-.189.047a2.846,2.846,0,0,0-1.653-.236h0l.094-.094,1.89-1.89a2.351,2.351,0,0,1,1.8-.708,2.383,2.383,0,0,1,2.268,2.128,2.314,2.314,0,0,1-.614,1.89l-2.41,2.41a2.361,2.361,0,0,1-1.653.661,3.129,3.129,0,0,1-1.275-.38Z",
    transform: "translate(1922.008 895.007)",
    fill: "#1b1c1d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.1dbf776ffb6cc0f4130b24b59d47d39a.svg";
export { ForwardRef as ReactComponent };